import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getHub } from './get-hub';

/** `POST /client/:cid/hubs/create {name}` (409 on a duplicate name), then the hub as cb returned it. */
export const createHub = async (name: string): Promise<any> => {
  const { id } = await lpRequest('POST', clientPath('/hubs/create'), {
    body: { name: name.trim() }
  });

  return getHub(id);
};
